import React from 'react';
import FormValidation from '../../../Componant/Forms/FormControl/FormValidation';

const FormValidationForm = () => {
  return (
    <div className='page-body'>
      <FormValidation />
    </div>
  );
};

export default FormValidationForm;
